import React, { useContext, useEffect, useState } from "react";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import "../../styles/styles.css";
import { useTranslation } from "react-i18next";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import userContext from "../../../../context/users/UserContext";
import { USERTYPES } from "../../../../constants/Constants";
import { getEnv } from '../../../../helpers/EnvHelper';

const PatientDetails = ({
  viewportData,
  showForceReinference,
  forceReinference,
  reportDoneStatusState
}) => {
  const {roles, qcOutsourceLogin} = useContext(userContext)
  const { t } = useTranslation();
  const { getConsistentDateFormat } = useContext(studyReportContext);
  return (
    <>
      <div className="viewport-overlay-patient">
        {viewportData && (
          <>
            <CustomToolTipHost content={`${t("viewer.overlay.patient-id")}: ${viewportData?.patientId}`} id="overlay-patient-id">
              <span style={{ lineHeight: "15px" }}>
                <span className="viewport-overlay-key">
                  {t("viewer.overlay.patient-id")}:{" "}
                </span>
                <span className="viewport-overlay-value">
                  {viewportData?.patientId}
                </span>
              </span>
            </CustomToolTipHost>
            {(getEnv("REACT_APP_VDC_PLATFORM") == "true" ||
              getEnv("REACT_APP_VDC_PLATFORM") == true) && (
              <CustomToolTipHost content={`${t("viewer.overlay.order-id")}: ${viewportData?.orderId}`} id="overlay-order-id">
                <span style={{ lineHeight: "15px" }}>
                  <span className="viewport-overlay-key">
                    {t("viewer.overlay.order-id")}:{" "}
                  </span>
                  <span className="viewport-overlay-value">
                    {viewportData?.orderId}
                  </span>
                </span>
              </CustomToolTipHost>
            )}
            <CustomToolTipHost content={`${t("viewer.overlay.patient-name")}: ${viewportData?.patientName}`} id="overlay-patient-name">
              <span style={{ lineHeight: "15px" }}>
                <span className="viewport-overlay-key">
                  {t("viewer.overlay.patient-name")}:{" "}
                </span>
                <span className="viewport-overlay-value">
                  {viewportData?.patientName}
                </span>
              </span>
            </CustomToolTipHost>
            {((roles[0] == USERTYPES.FIRMADMIN || (roles[0] == USERTYPES.SUPERVISOR && !qcOutsourceLogin)) &&
              (getEnv("REACT_APP_VDC_PLATFORM") == "false" || getEnv("REACT_APP_VDC_PLATFORM") == false) &&
              (getEnv("REACT_APP_BVP_PLATFORM") == "false" || getEnv("REACT_APP_BVP_PLATFORM") == false)) && (
              <CustomToolTipHost content={`${t("viewer.overlay.client-name")}: ${viewportData?.clientName || '-'}`} id="overlay-client-name">
                <span style={{ lineHeight: "15px" }}>
                  <span className="viewport-overlay-key">
                    {t("viewer.overlay.client-name")}:{" "}
                  </span>
                  <span className="viewport-overlay-value">
                    {viewportData?.clientName || '-'}
                  </span>
                </span>
              </CustomToolTipHost>
            )}
            <span
              className="viewport-overlay-value"
              style={{ lineHeight: "15px" }}
            >
              {viewportData?.patientAge?.slice(0, 1) === "0"
                ? viewportData?.patientAge?.slice(1, 3) === "-"
                  ? "-"
                  : viewportData?.patientAge?.slice(1, 3) + " | "
                : viewportData?.patientAge?.slice(0, 3) === "-"
                ? "-"
                : viewportData?.patientAge?.slice(0, 3)}{" | "}
              {viewportData?.patientSex === undefined ||
              viewportData?.patientSex === null ||
              viewportData?.patientSex === "-"
                ? "-"
                : viewportData?.patientSex === "M"
                ? t("viewer.overlay.male")
                : t("viewer.overlay.female")}
            </span>
            {(reportDoneStatusState == 0 || reportDoneStatusState == 1) && showForceReinference && (roles[0] !== USERTYPES.FIRMDOCTOR && roles[0] !== USERTYPES.FIRMTECHNICIAN) && (
              <span
                onClick={forceReinference}
                title={t("viewer.tools.force-reinference")}
              >
                <span className="svg-icon-force-reinference" />
              </span>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default PatientDetails;
